module.exports = __webpack_public_path__ + "img/typo@2x.52325c28.jpg";